import React from "react";

import Context from "shared/util/Context";

import Copyright from "shared/components/Footer/Copyright";
import SignupLink from "shared/components/Footer/SignupLink";

import "./Sidebar.scss";

const Sidebar = () => {
	const isLoggedIn = !!Context.get("userid");

	return (
		<div className="footer-sidebar">
			{isLoggedIn && <div className="footer-sidebar-logo" />}
			{!isLoggedIn && <SignupLink />}
			<Copyright />
		</div>
	);
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/Sidebar.jsx